import { EndSessionWarningModalModule } from '@app/components/modals/end-session-warning-modal/end-session-warning.modal-module';
import { HostComponent } from '@app/host/host.component';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { NgModule } from '@angular/core';

@NgModule({
	declarations: [HostComponent],
	imports: [EndSessionWarningModalModule, CommonModule, RouterModule],
})
export class HostModule {}
